import * as types from './mutation-types'

export default {
  [types.SET_NOTIFICATIONS](state, notifications) {
    state.notifications = notifications
  },
  
  [types.SET_PROFILES](state, profiles) {
    state.profiles = profiles
  },
  
  [types.SET_LOADING](state, loading) {
    state.loading = loading
  },
  
  [types.SET_LAST_FETCH](state, timestamp) {
    state.lastFetch = timestamp
  },
  
  [types.CLEAR_NOTIFICATIONS](state) {
    state.notifications = []
    state.quotationNotifications = []
    state.profiles = {}
    state.lastFetch = null
    state.lastQuotationFetch = null
  },
  
  [types.SET_TEST_MODE](state, enabled) {
    state.testMode = enabled
  },

  [types.SET_QUOTATION_NOTIFICATIONS](state, notifications) {
    state.quotationNotifications = notifications
  },

  [types.SET_QUOTATION_LOADING](state, loading) {
    state.quotationLoading = loading
  },

  [types.SET_LAST_QUOTATION_FETCH](state, timestamp) {
    state.lastQuotationFetch = timestamp
  }
}
